export default __webpack_public_path__ + "static/media/hybrid.ec1560c4.png";